export default __webpack_public_path__ + "static/media/pin.c69f9cd7.png";